import React, { useEffect, useRef, useState, useCallback } from "react";
import Styles from "./BilateralSearch.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getSearchListing } from "../../Services/BuySell/Listing";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import { ReactComponent as Download } from "../../assets/images/downloadFile.svg";

import { Slider } from "@mui/material";
import ReactDOM from "react-dom";

import { formatDateType } from "../../commons/FormatDate";
import ViewInjectionModal from "../Modals/ConGen/ViewInjectionModal/ViewInjectionModal";
import ConGenListingModal from "../Modals/ConGen/ConGenListingModal";
import { createListing, placeBidApi } from "../../Services/BuySell/Creation";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Skeleton } from "@mui/material";
import { getAllCreditRating } from "../../Services/ApiCalling/PublicApi";
import TimeInput from "../../commons/Inputs/TimeInputBailateral/TimeInput";
import { usePdfPreview } from "../../hooks/usePdfPreview";
import { fetchSearchListing } from "../../Redux/Slices/CapacitySlice";
import PreviewModal from "../../commons/PreviewModal/PreviewModal";
import { getDocumentUrlByLedgerId } from "../../Services/ApiCalling/banking";
import { downloadListing } from "../../Services/ApiCalling/Listing";
import { SuccessMessage } from "../../commons/Toast/ErrorMessage";
import { toast } from "react-toastify";

const BilateralSearch = () => {
  const searchList = useSelector(
    (state) => state?.CapacitySlice?.searchListing
  );

  const user = useSelector(
    (state) => state.persistedReducer.user?.activeRole
  )?.toLowerCase();
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [listype, setListype] = useState(false); // false for interstate, true for intrastate
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [createListingDataLoading, setCreateListingDataLoading] =
    useState(false);
  const state = useSelector(
    (state) => state?.persistedReducer?.company?.stateLabel
  );
  const dispatch = useDispatch();

  const [filterDraft, setFilterDraft] = useState({
    quantity: [0, 10000],
    energyRate: [0, 200],
    creditRating: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });

  const [errors, setErrors] = useState({});
  const [ratingsList, setRatingsList] = useState([]);

  const [filterState, setFilterState] = useState({
    quantity: [0, 10000],
    energyRate: [0, 200],
    creditRating: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });

  async function getCreditRatinga() {
    try {
      const ratings = await getAllCreditRating();
      if (ratings?.data?.code === 200) {
        setRatingsList(ratings?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching credit ratings:", error);
    }
  }

  useEffect(() => {
    getCreditRatinga();
  }, []);

  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  )?.toLowerCase();

  const loader = useSelector(
    (state) => state?.CapacitySlice?.searchListingLoading
  );

  const [viewReqData, setViewReqData] = useState(null);
  const [connectData, setConnectData] = useState(null);

  useEffect(() => {
    const fetchSearchList = async () => {
      try {
        let aa = role === "consumer" ? "generator" : "consumer";
        dispatch(
          fetchSearchListing({ user: aa, curr: 0, type: listype, state })
        );
      } catch (error) {
        console.error("Error fetching search listing:", error);
      }
    };

    if (role) {
      fetchSearchList();
    }
  }, [role, listype, state, dispatch]);

  const handleDirectConnect = async (id) => {
    let payload = {
      initiator: role,
      capacityConsumerId: role === "consumer" ? id : connectData?.id,
      capacityGeneratorId: role === "generator" ? id : connectData?.id,
      reason: "PRICE",
    };
    const response = await placeBidApi(payload);
    if (response?.data?.code === 200) {
      setConnectData(false);
      window.location.href = "/dashboard";
    }
  };

  const createUserListing = async (payload) => {
    console.debug(payload);

    try {
      setCreateListingDataLoading(true);
      let res = await createListing(payload, role);
      if (res?.data?.code === 200) {
        handleDirectConnect(res?.data?.data?.id);
      }
    } catch (error) {
      console.error("Error creating listing:", error);
    } finally {
      setCreateListingDataLoading(false);
    }
  };

  const skeletonRows = Array.from({ length: 5 });
  const filterRef = useRef(null);

  useEffect(() => {
    if (!isFilterOpen) {
      setErrors({}); // Reset errors when modal closes
      return;
    }

    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
        setErrors({}); // Reset errors when modal closes
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterOpen]);

  const validateFields = (state) => {
    const newErrors = {};

    // Quantity validation
    if (state.quantity[0] > state.quantity[1]) {
      newErrors.quantity = "Min quantity cannot be greater than max quantity";
    }

    // Energy Rate validation
    if (state.energyRate[0] > state.energyRate[1]) {
      newErrors.energyRate = "Min rate cannot be greater than max rate";
    }

    // Dates validation
    if (state.startDate && state.endDate && state.startDate > state.endDate) {
      newErrors.startDate = "Start date cannot be after end date";
      newErrors.endDate = "End date cannot be before start date";
    }

    // Time validation
    if (state.startTime && state.endTime && state.startTime >= state.endTime) {
      newErrors.startTime = "Start time must be before end time";
      newErrors.endTime = "End time must be after start time";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (!isFilterOpen) return;

    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterOpen]);

  async function handleDownload(data) {
    try {
      const response = await downloadListing(data.id, true);
      const blob = response.data;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/pdf",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `listing_${data.name}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Listing downloaded successfully!");
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to download listing."
      );
    }
  }

  const filterListings = useCallback(
    (list) => {
      const desiredIsInterstate = !listype;
      return list
        ?.filter((ele) => ele?.priceDiscoveryType === "BILATERAL")
        ?.filter((ele) => ele?.isInterstate === desiredIsInterstate);
      // For interstate, exclude listings from the same state
      // ?.filter((item) => {
      //   if (desiredIsInterstate && item?.stateLabel === state) {
      //     return false;
      //   }
      //   return true;
      // })
      // ?.filter((item) => {
      //   // Quantity
      //   const quantity =
      //     item?.slots?.[0]?.quantity ??
      //     item?.slots?.[0]?.sellEnergy ??
      //     item?.slots?.[0]?.purchaseEnergy ??
      //     0;
      //   if (
      //     quantity < filterState.quantity[0] ||
      //     quantity > filterState.quantity[1]
      //   ) {
      //     return false;
      //   }

      //   // Energy Rate
      //   const energyRate =
      //     item?.slots?.[0]?.amount ??
      //     item?.slots?.[0]?.sellingCost ??
      //     item?.slots?.[0]?.landingCost ??
      //     0;
      //   if (
      //     energyRate < filterState.energyRate[0] ||
      //     energyRate > filterState.energyRate[1]
      //   ) {
      //     return false;
      //   }

      //   // Credit Rating
      //   if (
      //     filterState.creditRating &&
      //     item?.creditRating !== filterState.creditRating
      //   ) {
      //     return false;
      //   }

      //   // Date Overlap Logic
      //   if (filterState.startDate && filterState.endDate) {
      //     const filterStart = new Date(filterState.startDate);
      //     const filterEnd = new Date(filterState.endDate);
      //     const slotStart = item?.slots?.[0]?.dateStartAt
      //       ? new Date(item.slots[0].dateStartAt)
      //       : null;
      //     const slotEnd = item?.slots?.[0]?.dateEndAt
      //       ? new Date(item.slots[0].dateEndAt)
      //       : null;

      //     // Only filter out if there is NO overlap
      //     if (
      //       slotStart &&
      //       slotEnd &&
      //       (slotEnd < filterStart || slotStart > filterEnd)
      //     ) {
      //       return false;
      //     }
      //   }

      //   // Time Overlap Logic
      //   if (filterState.startTime && filterState.endTime) {
      //     const slotStartTime = item?.slots?.[0]?.slotStartAt;
      //     const slotEndTime = item?.slots?.[0]?.slotEndAt;

      //     // Only filter out if there is NO overlap
      //     if (
      //       slotStartTime &&
      //       slotEndTime &&
      //       (slotEndTime < filterState.startTime ||
      //         slotStartTime > filterState.endTime)
      //     ) {
      //       return false;
      //     }
      //   }

      //   return true;
      // })
    },
    [listype]
  );

  const handleViewTermsDocument = async (termsDocumentId) => {
    if (!termsDocumentId || termsDocumentId === 0) {
      console.warn("No terms document ID available");
      return;
    }

    try {
      const response = await getDocumentUrlByLedgerId(termsDocumentId);
      const url = response?.data || response;
      if (url) {
        setPreviewFileUrl(url);
        setPreviewModal(true);
      } else {
        console.error("No URL found for terms document");
      }
    } catch (error) {
      console.error("Error viewing terms document:", error);
    }
  };

  const tableColumns = [
    { name: "Listing Id", width: "20%" },
    { name: "Requisitions", width: "15%" },
    { name: "Energy Type", width: "15%" },
    { name: "Terms & Conditions", width: "20%" },
    { name: "Listing Expiry", width: "20%" },
    { name: "Comment", width: "200px" },
    { name: "Action", width: "200px" },
  ];

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
  };

  return (
    <>
      <ViewInjectionModal
        open={viewReqData}
        handleClose={() => setViewReqData(null)}
        data={viewReqData}
      />
      {connectData && (
        <ConGenListingModal
          data={connectData}
          open={connectData}
          directConnect={true}
          handleClose={() => setConnectData(null)}
          handleSubmit={createUserListing}
          loading={createListingDataLoading}
          type={"search"}
        />
      )}

      {previewModal && (
        <PreviewModal
          open={previewModal}
          onClose={handleClosePreview}
          fileUrl={previewFileUrl}
          name="Terms and Conditions"
        />
      )}
      {isFilterOpen &&
        ReactDOM.createPortal(
          <div ref={filterRef} className={Styles.filterDropdown}>
            <div className={Styles.filterHeader}>
              <span>Filters</span>
            </div>
            <div className={Styles.filterContent}>
              <div>
                <div
                  style={{
                    background: "white",
                    padding: "20px",
                    borderRadius: "12px",
                  }}
                  className={Styles.filterRow}
                >
                  {/* Quantity */}
                  <div className={Styles.filterField}>
                    <label>Quantity (MW)</label>
                    <div className={Styles.rangeSlider}>
                      <div className={Styles.rangeValues}>
                        <span>{filterDraft.quantity[0]}</span>
                        <span>{filterDraft.quantity[1]}</span>
                      </div>
                      <Slider
                        value={filterDraft.quantity}
                        onChange={(e, newValue) =>
                          setFilterDraft({
                            ...filterDraft,
                            quantity: newValue,
                          })
                        }
                        min={0}
                        max={10000}
                        valueLabelDisplay="auto"
                        sx={{
                          color: "var(--primary-color-text)",
                          "& .MuiSlider-thumb": {
                            width: 18,
                            height: 18,
                            fontSize: "12px",
                            backgroundColor: "var(--primary-color-text)",
                            border: "3px solid white",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            "&:hover, &.Mui-focusVisible": {
                              boxShadow: "0 0 0 8px rgba(255, 107, 53, 0.16)",
                            },
                          },
                          "& .MuiSlider-track": {
                            height: 6,
                            border: "none",
                          },
                          "& .MuiSlider-rail": {
                            height: 6,
                            opacity: 0.3,
                            backgroundColor: "#ddd",
                          },
                        }}
                      />
                    </div>
                    {errors.quantity && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.quantity}
                      </div>
                    )}
                  </div>

                  {/* Energy Rate */}
                  <div className={Styles.filterField}>
                    <label>Energy Rate (kWh)</label>
                    <div className={Styles.rangeSlider}>
                      <div className={Styles.rangeValues}>
                        <span>{filterDraft.energyRate[0]}</span>
                        <span>{filterDraft.energyRate[1]}</span>
                      </div>
                      <Slider
                        value={filterDraft.energyRate}
                        onChange={(e, newValue) =>
                          setFilterDraft({
                            ...filterDraft,
                            energyRate: newValue,
                          })
                        }
                        min={0}
                        max={200}
                        valueLabelDisplay="auto"
                        sx={{
                          color: "var(--primary-color-text)",
                          "& .MuiSlider-thumb": {
                            width: 18,
                            height: 18,
                            backgroundColor: "var(--primary-color-text)",
                            border: "3px solid white",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                            "&:hover, &.Mui-focusVisible": {
                              boxShadow: "0 0 0 8px rgba(255, 107, 53, 0.16)",
                            },
                          },
                          "& .MuiSlider-track": {
                            height: 6,
                            border: "none",
                          },
                          "& .MuiSlider-rail": {
                            height: 6,
                            opacity: 0.3,
                            backgroundColor: "#ddd",
                          },
                        }}
                      />
                    </div>
                    {errors.energyRate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.energyRate}
                      </div>
                    )}
                  </div>

                  {/* Credit Rating */}
                  <div className={Styles.filterField}>
                    <label>Credit Rating</label>
                    <select
                      value={filterDraft.creditRating}
                      onChange={(e) =>
                        setFilterDraft({
                          ...filterDraft,
                          creditRating: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      {ratingsList.map((rating) => (
                        <option key={rating.id} value={rating.rating}>
                          {rating.rating}
                        </option>
                      ))}
                    </select>
                    {errors.creditRating && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.creditRating}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    background: "white",
                    padding: "20px",
                    borderRadius: "12px",
                    marginTop: "15px",
                  }}
                  className={Styles.filterRow}
                >
                  {/* Start Date */}
                  <div className={Styles.filterField}>
                    <label>Start Date</label>
                    <input
                      type="date"
                      value={filterDraft.startDate}
                      onChange={(e) =>
                        setFilterDraft({
                          ...filterDraft,
                          startDate: e.target.value,
                        })
                      }
                    />
                    {errors.startDate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.startDate}
                      </div>
                    )}
                  </div>

                  {/* End Date */}
                  <div className={Styles.filterField}>
                    <label>End Date</label>
                    <input
                      type="date"
                      value={filterDraft.endDate}
                      onChange={(e) =>
                        setFilterDraft({
                          ...filterDraft,
                          endDate: e.target.value,
                        })
                      }
                    />
                    {errors.endDate && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.endDate}
                      </div>
                    )}
                  </div>

                  {/* Start Time */}
                  <div className={Styles.filterField}>
                    <TimeInput
                      noTooltip={true}
                      isRtc={false}
                      type={"startTime"}
                      heading={"Start Time"}
                      value={filterDraft.startTime}
                      onChange={(value) =>
                        setFilterDraft({
                          ...filterDraft,
                          startTime: value,
                        })
                      }
                      startDate={filterDraft.startDate}
                      minutesStep={15}
                      height={35}
                    />
                    {errors.startTime && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.startTime}
                      </div>
                    )}
                  </div>

                  {/* End Time */}
                  <div className={Styles.filterField}>
                    <TimeInput
                      isRtc={false}
                      type={"endTime"}
                      heading={"End Time"}
                      value={filterDraft.endTime}
                      onChange={(value) =>
                        setFilterDraft({
                          ...filterDraft,
                          endTime: value,
                        })
                      }
                      startDate={filterDraft.endDate}
                      minutesStep={15}
                      height={35}
                    />
                    {errors.endTime && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.endTime}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className={Styles.filterActions}>
                <button
                  className={Styles.resetButton}
                  onClick={() => {
                    const reset = {
                      quantity: [0, 10000],
                      energyRate: [0, 100],
                      creditRating: "",
                      startDate: "",
                      endDate: "",
                      startTime: "",
                      endTime: "",
                    };
                    setFilterDraft(reset);
                    setFilterState(reset);
                  }}
                >
                  Reset
                </button>
                <button
                  className={Styles.applyButton}
                  onClick={() => {
                    if (validateFields(filterDraft)) {
                      setFilterState(filterDraft);
                      setIsFilterOpen(false);
                    }
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}

      <div className={Styles.searchMainContainer}>
        <div className={`display_flex_row ${Styles.searchHeaderContainer}`}>
          <div className="display_flex_row_gap_8_only">
            <div
              onClick={() => window.history.back()}
              className={`display_flex_row_gap_4_only ${Styles.backElem}`}
            >
              <ArrowBackIosIcon style={{ fontSize: "12px" }} />
              <span>Back</span>
            </div>
            <div className={Styles.availableHeading}>
              {user === "consumer"
                ? "All Available Sell Listings"
                : "All Available Buy Listings"}{" "}
            </div>
          </div>
          <div className="display_flex_row_gap_8_only">
            <div className={Styles.buttonContainerMain}>
              <div
                className={!listype && Styles.activeButton}
                onClick={() => setListype(false)}
              >
                Interstate
              </div>
              <div
                className={listype && Styles.activeButton}
                onClick={() => setListype(true)}
              >
                Intrastate
              </div>
            </div>
            <div
              className={`display_flex_row_center  ${Styles.filterButton}`}
              onClick={() => {
                setFilterDraft(filterState);
                setIsFilterOpen(true);
              }}
              onMouseDown={
                isFilterOpen ? (e) => e.stopPropagation() : undefined
              }
            >
              <span>Filter</span>
              <ExpandMoreIcon
                style={{
                  fontSize: "16px",
                  transform: isFilterOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </div>
          </div>
        </div>
        <div className={Styles.listingMainContainer}>
          <div className={`scroll_bar_y ${Styles.tableContainer}`}>
            <table className={Styles.dataTable}>
              <thead>
                <tr className="tableHeading">
                  {tableColumns.map((col, idx) => (
                    <th key={idx} style={{ width: col.width }}>
                      {col.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  skeletonRows.map((_, idx) => (
                    <tr key={idx} className="tableDetails">
                      {tableColumns.map((_, colIdx) => (
                        <td key={colIdx}>
                          <Skeleton variant="rectangular" height={32} />
                        </td>
                      ))}
                    </tr>
                  ))
                ) : filterListings(searchList)?.length === 0 ? (
                  <tr>
                    <td colSpan={tableColumns.length}>
                      <div
                        className={`display_flex_row_center ${Styles.noListings}`}
                      >
                        No {listype ? "Intrastate" : "Interstate"} listings
                        found
                      </div>
                    </td>
                  </tr>
                ) : (
                  filterListings(searchList)?.map((data, idx) => (
                    <tr key={data?.id || idx} className="tableDetails">
                      <td style={{ textAlign: "center" }}>{data?.name}</td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          className={Styles.viewReq}
                          onClick={() => setViewReqData(data)}
                        >
                          View Details
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {data?.energyFuelType}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          title={
                            data.termsDocumentId
                              ? "View Terms & Conditions"
                              : "T&C not available"
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewTermsDocument(data.termsDocumentId);
                          }}
                          disabled={!data.termsDocumentId}
                          className={Styles.tandContainer}
                          style={{
                            cursor: data.termsDocumentId
                              ? "pointer"
                              : "not-allowed",
                            opacity: data.termsDocumentId ? 1 : 0.6,
                          }}
                        >
                          <span>View T&C</span>
                          <CallMadeOutlinedIcon
                            style={{ fontSize: "10px", marginTop: "-10px" }}
                          />
                        </button>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {formatDateType(data?.listingExpDate)}{" "}
                        {data?.listingExpTime}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <span
                          title={data?.comment || "-"}
                          style={{
                            display: "inline-block",
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {data?.comment || "-"}
                        </span>
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <button
                            className={`activeButton ${Styles.connectButton}`}
                            onClick={() => setConnectData(data)}
                          >
                            Connect
                          </button>

                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDownload(data)}
                          >
                            <Download />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default BilateralSearch;
